import type { AgentDefinitionSummary } from '@erp/rpc';

/**
 * Agents a task can be routed to: active, not archived, and set up (at least
 * one tool or a template). A blank "New Agent" that was never configured is
 * left out. The currently saved agent always stays, so a saved setting never
 * shows as empty.
 */
export function assignableAgents<
  A extends Pick<
    AgentDefinitionSummary,
    'id' | 'isActive' | 'toolCount' | 'templateType' | 'deletedAt'
  >,
>(definitions: readonly A[], selectedId: string): A[] {
  return definitions.filter(
    (agent) =>
      agent.id === selectedId ||
      (agent.isActive &&
        !agent.deletedAt &&
        (agent.toolCount > 0 || Boolean(agent.templateType))),
  );
}
